<template>
  <div>
    <el-row>
      <el-col :span="24" style="text-align: left;"><el-button type="primary" size="small" round
          @click="openDialog(null)">添加</el-button></el-col>
    </el-row>

    <table>
      <tr>
        <td>
          <el-table :data="tableData" border style="width: 100%" @row-click="handleRowClick">
            <el-table-column prop="name" label="名称" width="580">
            </el-table-column>
            <!-- <el-table-column  label="描述">
              <template slot-scope="scope">
                 <div class="cell-ellipsis" v-html="scope.row.description"></div>
              </template>
            </el-table-column> -->
            <el-table-column label="操作" width="360">
              <template #default="scope">
                <el-tooltip content="修改" placement="top">
                  <el-button type="primary" size="mini" icon="el-icon-edit" circle @click="openDialog(scope.row)"
                    style="margin-left: 20px;"></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="deleteNews(scope.row.id)"
                    style="margin-left: 20px;"></el-button>
                </el-tooltip>
                <el-tooltip content="详情" placement="top">
                  <el-button type="warning" size="mini" icon="el-icon-star-off" circle @click="showDetail(scope.row.id)"
                    style="margin-left: 20px;"></el-button>
                </el-tooltip>

                <el-tooltip content="分配" placement="top">
                  <el-button type="primary" size="mini" icon="el-icon-share" circle @click="shareToProduct(scope.row)"
                    style="margin-left: 20px;"></el-button>
                </el-tooltip>
              </template>

            </el-table-column>
          </el-table>
        </td>
        <td>
          <el-table :data="rightProduct" border style="width: 100%">
            <el-table-column prop="code" label="编码" width="180">
            </el-table-column>
            <el-table-column prop="name" label="名称" width="480">
            </el-table-column>
          </el-table>
        </td>
      </tr>
    </table>
    <!-- 详情 弹窗 -->
    <el-dialog title="提示" :visible.sync="isdetail" width="60%" :before-close="detailClose">
      <div v-html="detailInfo" class="preview" style="overflow: auto; max-height: 800px;"></div>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="60%">
      <el-form :model="currentRow">

        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input placeholder="请输入名称" v-model="currentRow.name" style="display: inline;margin-left: 5px; " clearable
            required>
          </el-input>
        </el-form-item>

        <el-form-item label="描述" :label-width="formLabelWidth">
          <!-- <vue-editor v-model="currentRow.content" :options="editorOptions"></vue-editor> -->
          <ckeditor v-model="currentRow.description" :config="editorConfig"></ckeditor>
        </el-form-item>
        <el-form-item label="PDF" :label-width="formLabelWidth">
          <el-upload class="avatar-uploader" :before-upload="beforeUpload" action="" :show-file-list="false"
            :on-change="handleFileChange" :file-list="fileList">
            <div v-if="currentRow.url">
              <embed :src="currentRow.url" type="application/pdf" width="100%" height="600px">
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveInfo">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="分配" :visible.sync="isAllotDialog" width="60%">
      <el-table ref="multipleTable" :data="popAllotData" tooltip-effect="dark" height="600" style="width: 100%;"
        row-key="id">
        <el-table-column label="选择" width="55">
          <template #default="scope">
            <el-checkbox v-model="scope.row.isBook">
            </el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="产品编码" width="180">
        </el-table-column>
        <el-table-column prop="name" label="产品名称" width="500">
        </el-table-column>
      </el-table>
      <div class="button-group">
        <el-button size="mini" round @click="saveProduct">确认</el-button>
        <el-button size="mini" round @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>

  import { getBookListNoContent, getBookList, delBookHand, submitBookHand, addProductBook, getProductBookList, getBookProDataList } from "@/api/rbac/bookHand";
  // import { VueEditor } from "vue2-editor";


  export default {
    components: {},
    data() {
      return {
        dialogVisible: false,

        newsData: [],
        currentRow: { id: 0, name: '', description: '', url: '', date: new Date(), remark: '' },
        formLabelWidth: '120px',
        fileList: [],
        isImage: false,
        isVideo: false,
        isdetail: false,
        detailInfo: "",
        content: '',
        editorConfig: {
          extraPlugins: 'font,colorbutton', // 添加字体和颜色插件
          toolbar: [
            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'] },
            { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
            { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
            { name: 'colors', items: ['TextColor', 'BGColor'] },
            // { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 视频功能
            { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 添加图片按钮
            { name: 'links', items: ['Link', 'Unlink'] },
          ],
          font_names: 'Arial/Arial, Helvetica, sans-serif;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif',
          fontSize_sizes: '9/9px;11/11px;13/13px;16/16px;18/18px;21/21px;24/24px;28/28px;32/32px',
          language: 'zh-cn'
        },
        tableData: [],
        isFirstOpen: true,
        isAllotDialog: false,
        bookID: 0,
        popAllotData: [],
        rightProduct: [],
      }
    },
    mounted() {
      this.content = '<p style="font-size:14px; font-family:Microsoft-YaHei">示例文本</p>'

    },
    beforeCreate() {

    },
    created() {
      this.loadDataList();
    },
    methods: {

      async loadDataList() {
        try {
          getBookListNoContent().then(res => {
            if (res.data.length == 0) {
              // console.log(this.dataList)
            }
            else {
              this.tableData = res.data;
              this.tableData.forEach(comNew => {
                comNew.url = "../../../assets/img/handbook/" + comNew.url;
              });
            }
          })
        } catch (error) {
          console.error('获取失败:', error);
        }
      },
      rowClick(item) {
        this.currentRow = { ...item }
      },

      openDialog(item) {
        this.dialogVisible = true

        // 深拷贝避免直接修改原数据
        if (item) {
          this.currentRow = { ...item }
          //获取明细
          try {
            getBookList({ strWhere: ' and a.id=' + item.id }).then((res) => {
              if (res.data.length == 0) {
                this.content = '';
              }
              else {
                this.currentRow.description = res.data[0].description
              }
            });
            // this.currentRow={ id: item.id, title: item.title, summary: item.summary, content: '<p>123</p>', year: item.year, monthDay: item.monthDay, url: item.url };

          } catch (error) {
            console.log(error);
          }
        } else {
          this.currentRow = { id: 0, name: '', description: '', url: '', date: new Date(), remark: '' };
        }
        if (this.isFirstOpen) {
          this.checkInterval = setInterval(() => {
            const dynamicDivs = document.querySelectorAll('.cke_notifications_area');

            if (dynamicDivs.length > 0) {
              dynamicDivs.forEach((div) => {
                div.style.display = 'none'
              });
              clearInterval(this.checkInterval); // 停止轮询
              this.isFirstOpen = false;
              // 可以在这里执行加载后的操作
              // 如果只需要检查一次，可以调用 clearInterval(this.checkInterval);
            }
          }, 100); // 每 500ms 检查一次
        }

      },
      beforeUpload(file) {
        const isImage = file.type.startsWith('image/');
        const isVideo = file.type.startsWith('video/');
        if (isImage) {
          this.isImage = true;
          this.isVideo = false;
        } else if (isVideo) {
          this.isVideo = true;
          this.isImage = false;
        }
        return false; // 阻止自动上传
      },
      handleFileChange(file, fileList) {
        //this.fileList = fileList;
        console.log('fileList', fileList)
        this.fileList = [];
        this.fileList.push(file)
        if (file.status === 'ready') {
          // 当文件状态为 ready 时，生成预览 URL
          const reader = new FileReader();
          reader.onload = (e) => {
            this.currentRow.url = e.target.result;
          };
          reader.readAsDataURL(file.raw);
        }
      },
      saveInfo() {

        if (!String(this.currentRow.name).trim()) {
          return alert("请填写名称")
        }
        if (!String(this.currentRow.description).trim()) {
          return alert("请填写描述")
        }
        if (this.fileList.length == 0 && this.currentRow.id == 0) {
          return alert("请选择图片")
        }
        const formData = new FormData();
        this.fileList.forEach((file) => {
          formData.append('files[]', file.raw);
        });
        formData.append("strType", "handbook")
        formData.append("ID", this.currentRow.id)
        formData.append("name", this.currentRow.name)
        formData.append("description", this.currentRow.description)
        formData.append("remark", this.currentRow.remark)
        try {
          submitBookHand(formData).then(res => {
            if (res.length == 0) {
              alert('失败');
            }
            else {
              alert('成功');
              this.dialogVisible = false;
              this.currentRow = { id: 0, name: '', description: '', url: '', date: new Date(), remark: '' };
              this.loadDataList();

            }
          })
        } catch (error) {
          alert('未成功');
        }
      },
      showDetail(id) {
        try {
          getBookList({ strWhere: ' and a.id=' + id }).then((res) => {
            if (res.data.length == 0) {
              this.content = '';
            }
            else {
              this.detailInfo = res.data[0].description;
              this.detailInfo = this.detailInfo.replace(/<p>\s*<span\s+style="color:\s*black;">/gi, `<p><span style="color: white;">`);

            }

          });

        } catch (error) {
          console.log(error);
        }
        this.isdetail = true;
      },
      deleteNews(id) {
        this.$confirm('确定删除该, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          try {
            delBookHand(id).then(res => {
              if (res.data == "ok") {
                this.loadDataList();
              }
            })

            this.currentRow = {};
          } catch (error) {
            console.error('删除失败:', error);
          }
        }).catch(() => {
        });
      },
      shareToProduct(item) {
        this.isAllotDialog = true
        this.getProduct(item.id)
        this.bookID = item.id
      },
      closeDialog() {
        this.isAllotDialog = false
      },
      detailClose() {
        this.detailInfo = "";
        this.isdetail = false;
      },
      handleRowClick(row) {
        getBookProDataList({ strWhere: ' and bookID=' + row.id }).then(res => {
          this.rightProduct = []
          if (res.data.length > 0) {
            this.rightProduct = res.data
          }
        })
      },
      getProduct(id) {
        getProductBookList({ strWhere: ' and bookID=' + id }).then(res => {
          this.popAllotData = []
          res.data.forEach(row => {
            var isBook = false
            if (row.isBook == 1) {
              isBook = true
            }
            this.popAllotData.push({ id: row.id, code: row.code, name: row.name, bookID: row.bookID, isBook: isBook })
          })
        })
      },
      saveProduct() {
        const datarows = []
        this.popAllotData.forEach(element => {
          if (element.isBook) {
            datarows.push({ id: 0, bookID: this.bookID, productID: element.id, remark: '' })
          }
        });
        addProductBook(datarows).then(res => {
          if (res.data == 'ok') {
            this.isAllotDialog = false;
            this.popAllotData = [];
            getBookProDataList({ strWhere: ' and bookID=' + this.bookID }).then(res => {
              this.rightProduct = []
              if (res.data.length > 0) {
                this.rightProduct = res.data
              }
            })
          }
        })
      }
    },

  }
</script>
<style>
  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
  }

  .avatar-uploader:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  /* 覆盖字体下拉菜单的显示文本 */
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimSun"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimSun"]::before {
    content: "宋体";
    font-family: "SimSun";
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimHei"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimHei"]::before {
    content: "黑体";
    font-family: "SimHei";
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Microsoft-YaHei"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Microsoft-YaHei"]::before {
    content: "微软雅黑";
    font-family: "Microsoft YaHei";
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before {
    content: "Arial";
    font-family: "Arial";
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Times-New-Roman"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Times-New-Roman"]::before {
    content: "Times New Roman";
    font-family: "Times New Roman";
  }
</style>